// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"6d5c725b22e1c665","3136":"99f602c32c85fd77","5431":"9060b101d2b8e1ff","8537":"bcbe04f7e5d9d3c0"}[chunkId] + ".js";
};